// Isomorphic constants shared by the browser measurement module and the
// server-side collector/weekly report. Keep this file free of browser APIs
// and client-only imports so it bundles cleanly on both sides.

export const MEASURED_PAGES = [
  "/services/hiatal-hernia-surgery",
  "/services/revisions/sleeve",
  "/es/reparacion-de-hernia-hiatal",
  "/es/cirugia-de-revision/manga-gastrica",
] as const;

export const CTA_LABELS: Record<(typeof MEASURED_PAGES)[number], string[]> = {
  "/services/hiatal-hernia-surgery": ["cta_hiatal_after_recommendation", "cta_hiatal_after_recovery", "cta_hiatal_after_insurance"],
  "/services/revisions/sleeve": ["cta_sleeve_revision_after_options", "cta_sleeve_revision_after_bypass_gallery", "cta_sleeve_revision_after_results", "cta_sleeve_revision_after_insurance"],
  "/es/reparacion-de-hernia-hiatal": ["cta_hiatal_after_recommendation_es", "cta_hiatal_after_recovery_es", "cta_hiatal_after_insurance_es"],
  "/es/cirugia-de-revision/manga-gastrica": ["cta_sleeve_revision_after_options_es", "cta_sleeve_revision_after_bypass_gallery_es", "cta_sleeve_revision_after_results_es", "cta_sleeve_revision_after_insurance_es"],
};
